import { ref, watch } from 'vue';
import { useStore } from '@/store';
import { globalData } from '@/global';
import { useTrack } from '@/hooks/useTrack';
export function useInvite () {
  const showInvite = ref(false);
  const store = useStore();
  const unWatch = watch(() => store.state.pageDataReady, openInvite);
  const { trackPopup } = useTrack();
  function openInvite (pageDataReady: boolean) {
    //未组队就打开弹窗
    if (globalData.isKuaikan && !store.state.isShare && pageDataReady && store.state.currentMembers.length <= 0) {
      showInvite.value = true;
      trackPopup('首访引导弹窗');
    }
    pageDataReady && unWatch();
  }
  return {
    showInvite,
    openInvite
  };
}